export default __webpack_public_path__ + "static/media/77_Agent_Thonburi_header_requisition.e0ce36a4.png";